import React, { Component } from 'react';

class Loading extends Component {
  constructor(props) {
    super(props);
    this.state = {imageLoaded: false};
  }
  render() {
    return (
      <div className="loading">
        <div className="loading1"></div>
        <div className="loading_container"><div className="loading2"></div></div>
      </div>
    );
  }
}

export default Loading;



// WEBPACK FOOTER //
// ./src/Loading.js